(function () {
  const SELECTOR = {
    root: '[data-magio-related-card]',
    slide: '[data-magio-related-slide]',
    dot: '[data-magio-related-dot]',
    prev: '[data-magio-related-prev]',
    next: '[data-magio-related-next]',
    quickView: '[data-magio-quick-view]',
  };

  function getSlides(card) {
    return Array.from(card.querySelectorAll(SELECTOR.slide));
  }

  function getActiveIndex(slides) {
    return slides.findIndex((slide) => slide.classList.contains('is-active'));
  }

  function setSlide(card, index) {
    const slides = getSlides(card);
    if (!slides.length) return;

    const maxIndex = slides.length - 1;
    const nextIndex = Math.max(0, Math.min(index, maxIndex));

    slides.forEach((slide, i) => {
      const isActive = i === nextIndex;
      slide.classList.toggle('is-active', isActive);
      slide.hidden = !isActive;
    });

    card.querySelectorAll(SELECTOR.dot).forEach((dot) => {
      const dotIndex = Number(dot.dataset.magioRelatedDot);
      const isActive = dotIndex === nextIndex;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    const prev = card.querySelector(SELECTOR.prev);
    const next = card.querySelector(SELECTOR.next);
    if (prev) prev.disabled = nextIndex === 0;
    if (next) next.disabled = nextIndex === maxIndex;
  }

  function initCard(card) {
    if (card.dataset.magioRelatedInit === 'true') return;
    card.dataset.magioRelatedInit = 'true';

    const slides = getSlides(card);
    if (slides.length <= 1) return;

    setSlide(card, getActiveIndex(slides));
  }

  function initCards(container) {
    container.querySelectorAll(SELECTOR.root).forEach(initCard);
  }

  function observeRecommendations() {
    document.querySelectorAll('product-recommendations.related-products--magio-cards').forEach((el) => {
      initCards(el);
      const observer = new MutationObserver(() => initCards(el));
      observer.observe(el, { childList: true, subtree: true });
    });
  }

  document.addEventListener('click', (event) => {
    const quickViewBtn = event.target.closest(SELECTOR.quickView);
    if (quickViewBtn) {
      event.preventDefault();
      const modal = document.querySelector(quickViewBtn.dataset.modal);
      if (modal && typeof modal.show === 'function') {
        modal.show(quickViewBtn);
      }
      return;
    }

    const card = event.target.closest(SELECTOR.root);
    if (!card) return;

    const prev = event.target.closest(SELECTOR.prev);
    const next = event.target.closest(SELECTOR.next);
    const dot = event.target.closest(SELECTOR.dot);

    if (prev) {
      event.preventDefault();
      setSlide(card, getActiveIndex(getSlides(card)) - 1);
    } else if (next) {
      event.preventDefault();
      setSlide(card, getActiveIndex(getSlides(card)) + 1);
    } else if (dot) {
      event.preventDefault();
      setSlide(card, Number(dot.dataset.magioRelatedDot));
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeRecommendations);
  } else {
    observeRecommendations();
  }
})();
